export default "<app-navigation layout=\"horizontal\"></app-navigation>\r\n";